import {AdminFailedNotifications, AdminOrderItemConfigurations, AdminOrders, BffAdminOofWeb, BffOofWeb, ConfigTemplatesAdmin, ConfigTemplatesCustomer, MeUser, OrderDeviceAllocationAdmin, OrderItemConfigurations, OrderItemDevices, OrderItems, Orders, RmaAdmin, RmaCustomer, System, Users} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public AdminFailedNotifications: AdminFailedNotifications,
    public AdminOrderItemConfigurations: AdminOrderItemConfigurations,
    public AdminOrders: AdminOrders,
    public BffAdminOofWeb: BffAdminOofWeb,
    public BffOofWeb: BffOofWeb,
    public ConfigTemplatesAdmin: ConfigTemplatesAdmin,
    public ConfigTemplatesCustomer: ConfigTemplatesCustomer,
    public MeUser: MeUser,
    public OrderDeviceAllocationAdmin: OrderDeviceAllocationAdmin,
    public OrderItemConfigurations: OrderItemConfigurations,
    public OrderItemDevices: OrderItemDevices,
    public OrderItems: OrderItems,
    public Orders: Orders,
    public RmaAdmin: RmaAdmin,
    public RmaCustomer: RmaCustomer,
    public System: System,
    public Users: Users,
  ) {}
}